export default __webpack_public_path__ + "static/media/adm.61d975f7.svg";